export default "__VITE_ASSET__Ch_3u7Xk__"